import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { DataAutomation } from '.';
import { CollapsibleRowCompTableCellStyle, CollapsibleRowCompTableRowStyle } from './styled';
type CollapsibleRowCompProps<P> = {
  row: P,
  open: boolean,
  hiddenColsOnMobile?: number[],
  align?: string,
  dataAutomation?: DataAutomation,
  innerFooterRowIndexes?: number[]
}

export const CollapsibleRowComp = ({
  row,
  open,
  hiddenColsOnMobile = [],
  align,
  dataAutomation,
  innerFooterRowIndexes
}: CollapsibleRowCompProps<any>) => {
  const openClassName = `${open ? 'open' : ''}`;

  const rows = Object.keys(row).map((key, i) => {
    const footerClassName = innerFooterRowIndexes?.includes(i) ? 'footerRow' : '';
    return (
      <TableRow
        data-automation={dataAutomation?.collapsibleRow ?? 'collapsibleRow'}
        className={`${openClassName} ${footerClassName}`}
        sx={CollapsibleRowCompTableRowStyle}
        key={i}
      >
        {Object.values(row[key]).map((val: any, i) => (
          <TableCell
            className={`${hiddenColsOnMobile.includes(i) ? 'hiddenOnMobile' : ''} ${align ? 'threeLevel' : ''}`}
            sx={CollapsibleRowCompTableCellStyle(align)}
            key={i}
          >
            <Typography component={"div"}>{val}</Typography>
          </TableCell>
        ))}
      </TableRow >
    )
  });

  return (
    <>{align ? <TableBody>{rows}</TableBody> : rows}</>
  )
}